<!-- 会员等级标签 -->
<template>
  <div class="vip-icon" v-if="memberLevelIcon">
    <img :src="memberLevelIcon" />
  </div>
</template>
<script>
  import { isIntegerInRange } from '@/app-shared/utils/tool';
  export default {
    props: {
      sourceLevel: Number,
      default: -1
    },
    computed: {
      // 会员等级设置信息
      member_level() {
        return this.$domainStore.state.roomBaseServer.member_level;
      },
      memberLevelIcon() {
        if (this.member_level?.status == 1 && isIntegerInRange(this.sourceLevel, 1, 21)) {
          if (this.member_level?.type === 'custom') {
            const item = (this.member_level?.custom_list || []).find(
              item => item.level == this.sourceLevel
            );
            if (item && item.icon) {
              return item.icon;
            }
            return '';
          } else {
            return require(`./images/vip${this.sourceLevel}.png`);
          }
        }
        return '';
      }
    }
  };
</script>
<style lang="less" scoped>
  .vip-icon {
    img {
      height: 100%;
      object-fit: contain;
    }
  }
</style>
